'use client'

import Tours from './components2/Tours'
import Trips from './components2/PriceTrips'
import Blog from './components2/Blog'
import WeContent from './components2/WeContent'
import Footer from './components2/Footer'
import Hero from './components2/Hero'
import Header from './components2/Header'
import SocialButtons from './components2/SocialButtons'

export default function Example() {

  return (
    <div className="bg-white">
      <div className="fixed top-0 left-0 right-0 z-50">
        <Header />
      </div>
      <div className="h-[90px]" /> 
      <main className="isolate">
        <section className="scroll-mt-[90px]" id="inicio">
          <Hero />
        </section>
        <section className="scroll-mt-[90px]" id="tours">
          <Tours />
        </section>
        <section className="scroll-mt-[100px] mt-24" id="viajes">
          <Trips />
        </section>
        <section className="scroll-mt-[90px]" id="opiniones">
          <Blog />
        </section>
        <section className="scroll-mt-[90px]" id="Mision">
          <WeContent />
        </section>
      </main>

      <section className="mt-8" id="contactanos">
        <Footer />
      </section>
      < SocialButtons />
    </div>
  )
}
